/* Local, replaceable audio assets. Drop the final files here:
   frontend/public/sounds/new-order.mp3
   frontend/public/sounds/customer-arrived.mp3
   Missing files or blocked autoplay must never break the Dashboard. */
export const SOUNDS_DIR = "/sounds";

export function playNotificationSound(file) {
  if (!file) return;
  try {
    const src = file.startsWith("/") || file.startsWith("http")
      ? file
      : `${SOUNDS_DIR}/${file}`;
    const audio = new Audio(src);
    audio.volume = 1;
    const p = audio.play();
    if (p && typeof p.catch === "function") p.catch(() => {});
  } catch (e) {
    /* autoplay blocked or asset missing — ignore */
  }
}
